module.exports = __webpack_public_path__ + "img/jl.c5b74f91.png";